import ErrorModel from '@/api/models/ErrorModel';
import { getWalletData } from '@/api/top-level-apis/wallet/wallet';
import { RoutingRouteEnum } from '@/router/routes.enum';
import store from '@/store';
import { Route } from 'vue-router';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useActions } = createNamespacedHelpers(store, 'wallet');

export const useWalletGuard = async (to: Route, from: Route) => {
  const { setWalletInfo } = useActions(['setWalletInfo']);
  if (
    to.matched.some((route) => route.meta.requireAuth) &&
    to.matched.some((route) => route.meta.requireAccountStepsCompletion) &&
    to.name !== RoutingRouteEnum.Wallet
  ) {
    const response = await getWalletData();

    if (response instanceof ErrorModel || !response.result) {
      setWalletInfo(null);
      return;
    }

    setWalletInfo(response.result);
  }
};
